import React from 'react';
import { assest } from '../../Assest/Assest';

function DentalImplants() {
  return (
    <div style={styles.container}>
      <img 
        src={assest.DentalImplants}
        alt="Dental Implants"
        style={styles.image}
      />
      <div style={styles.content}>
        <h2 style={styles.title}>Transform Your Smile with Dental Implants</h2>
        <p style={styles.text}>
          Dental implants are a revolutionary solution for replacing missing teeth, offering a natural look, feel, and function. 
          Unlike dentures, dental implants are securely anchored in your jawbone, providing a permanent and stable foundation 
          for artificial teeth.
        </p>
        <p style={styles.text}>
          Whether you're missing one tooth or several, our dental implant specialists offer personalized treatment plans to 
          restore your smile. The process involves placing a titanium post into the jawbone, which acts as a sturdy root for 
          your new teeth. Over time, the implant fuses with the bone, creating a lasting, strong foundation for your replacement teeth.
        </p>
        <p style={styles.text}>
          Book a consultation with us today to learn how dental implants can improve your quality of life, help restore your 
          confidence, and give you a beautiful, functional smile!
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: '#f9f9f9',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
    maxWidth: '900px',
    margin: '0 auto',
    textAlign: 'center',
  },
  containerHover: {
    transform: 'translateY(-10px)',
  },
  image: {
    width: '100%',
    maxWidth: '800px',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
  },
  imageHover: {
    transform: 'scale(1.05)',
  },
  content: {
    marginTop: '30px',
  },
  title: {
    fontSize: '2.5rem',
    color: '#2e2e2e',
    fontWeight: '700',
    marginBottom: '20px',
  },
  text: {
    fontSize: '1.1rem',
    color: '#555',
    lineHeight: '1.7',
    maxWidth: '800px',
    margin: '0 auto',
    paddingBottom: '10px',
    transition: 'color 0.3s ease-in-out',
  },
  textHover: {
    color: '#4caf50',
  },
};

export default DentalImplants;
